import { Component } from '@angular/core';

@Component({
  template: `
  <div style="text-align: center; padding: 20px;">
    <h1>4 ☹ 4</h1>
    <h1> This is not the page you were looking for!</h1>
  </div>
    `
})
export class PageNotFoundComponent { }
